import { makeStyles } from "@material-ui/core";

export const useListStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
  disabled: {
    ...theme.list.itemDisabled,
  },
  submissionRowDetails: {
    paddingRight: "20px",
  },
}));